import React from 'react';
import {
  Card,
  CardContent,
  Box,
  Typography,
  Avatar
} from '@mui/material';
import { Icon } from '@iconify/react';

const AnalyticsKPICard = ({
  title,
  value,
  subtitle,
  icon,
  color = "primary",
  showTrend = false,
  trendValue,
  trendIcon,
  isCurrency = false,
  unit = "",
  trendSubtitle
}) => {
  const formatValue = (val) => {
    if (isCurrency) {
      return `${val.toLocaleString()}`;
    }
    return `${val.toLocaleString()}${unit}`;
  };

  return (
    <Card sx={{ position: 'relative', overflow: 'visible' }}>
      <CardContent sx={{ p: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Box sx={{ flex: 1 }}>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
            {title}
          </Typography>
          
          <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 0.5 }}>
            {formatValue(value)}
          </Typography>
          
          {showTrend && trendValue && (
            <Box sx={{ display: 'flex', alignItems: 'center', mt: subtitle ? 0 : 1.5 }}>
              <Icon 
                icon={trendIcon} 
                width={14} 
                height={14} 
                style={{ marginRight: 4 }}
              />
              <Typography
                variant="caption"
                color={`${color}.main`}
                sx={{ fontWeight: 'medium', marginRight: 1 }}
              >
                {trendValue}
              </Typography>
              {trendSubtitle && 
              <Typography
                variant="caption" 
                color="text.secondary"
                sx={{ fontWeight: 'medium' }}
              >
                {trendSubtitle}
              </Typography>}
            </Box>
          )}
          
          {subtitle && (
            <Typography variant="caption" color="text.secondary">
              {subtitle}
            </Typography>
          )}
        </Box>
        
        <Avatar
          sx={{
            bgcolor: `${color}.lighter`,
            color: `${color}.main`,
            width: 40,
            height: 40,
            ml: 2
          }}
        >
          <Icon icon={icon} width={20} height={20} />
        </Avatar>
      </CardContent>
    </Card>
  );
};

export default AnalyticsKPICard;
